import { createApp } from 'vue';
import Redeem from "./Redeem.vue";
import { i18n } from '../../i18n';

const element = document.getElementById('redeem-app');

if (element) {
  const app = createApp(Redeem);
  app.use(i18n);
  app.mount(element);
}
